export default "__VITE_ASSET__uxGJBuzx__"